// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/magnifier/magnifier-control.scss
// module id = 438
// module chunks = 0